module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"New Member Registration","description":"School employees and corporate recruiters cannot register as members from this screen.","sign_up":"Member Registration (Free)","sign_in":"Sign In","for_school":"For school officials, click here.","for_corporate":"For corporate recruiters, click here."}}')
  delete Component.options._Ctor
}
